(function () {
  'use strict';

  function normalize(value) {
    return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function labelInput(input) {
    if (!input || input.getAttribute('aria-label')) return;
    if (input.id && document.querySelector('label[for="' + CSS.escape(input.id) + '"]')) return;

    var clue = normalize([
      input.name,
      input.id,
      input.placeholder,
      input.getAttribute('autocomplete')
    ].filter(Boolean).join(' '));

    if (clue.indexOf('email') !== -1) {
      input.setAttribute('aria-label', 'Checkout email address');
    } else if (clue.indexOf('order') !== -1) {
      input.setAttribute('aria-label', 'Order number');
    } else if (clue.indexOf('track') !== -1 || clue.indexOf('number') !== -1) {
      input.setAttribute('aria-label', 'Tracking number');
    }
  }

  function hideLegacyCopy(widget) {
    var legacyPhrases = [
      'track your kawaii stop order - stay informed and get excited',
      'stay informed and get excited'
    ];

    Array.prototype.forEach.call(widget.querySelectorAll('h1, h2, h3, p, div, span'), function (node) {
      if (node.children.length) return;
      var text = normalize(node.textContent);
      if (!text) return;

      var matches = legacyPhrases.some(function (phrase) {
        return text === phrase || text.indexOf(phrase) === 0;
      });

      if (matches) {
        node.setAttribute('data-ks-track-legacy-hidden', 'true');
        node.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function hideUnrelatedGallery(widget) {
    var labels = Array.prototype.slice.call(widget.querySelectorAll('h1, h2, h3, p, div, span, a'));

    labels.some(function (node) {
      if (node.children.length) return false;
      var text = normalize(node.textContent);
      if (text.indexOf('kawaiistop_official') === -1 && text.indexOf('@kawaiistop') === -1) return false;

      var candidate = node.parentElement;
      var depth = 0;

      while (candidate && candidate !== widget && depth < 6) {
        var imageCount = candidate.querySelectorAll('img').length;
        var hasLookup = candidate.querySelector('form, input, button, [role="form"]');

        if (imageCount >= 4 && !hasLookup) {
          candidate.setAttribute('data-ks-track-gallery-hidden', 'true');
          candidate.setAttribute('aria-hidden', 'true');
          return true;
        }

        candidate = candidate.parentElement;
        depth += 1;
      }

      return false;
    });
  }

  function enhanceWidget(widget) {
    if (!widget) return false;

    hideLegacyCopy(widget);
    hideUnrelatedGallery(widget);
    Array.prototype.forEach.call(widget.querySelectorAll('input'), labelInput);

    var interactive = widget.querySelector('form, input, button, track123-tracking-widget, [class*="track" i]');
    if (interactive) {
      widget.setAttribute('data-ks-track-widget-ready', 'true');
      return true;
    }

    return false;
  }

  function init() {
    var page = document.querySelector('[data-ks-tracker-page]');
    var widget = document.querySelector('[data-ks-track-widget]');
    if (!page || !widget || page.dataset.ksTrackerReady === 'true') return;

    page.dataset.ksTrackerReady = 'true';
    enhanceWidget(widget);

    var observer = new MutationObserver(function () {
      enhanceWidget(widget);
    });

    observer.observe(widget, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 8000);

    var params = new URLSearchParams(window.location.search);
    if (params.has('nums')) {
      window.setTimeout(function () {
        widget.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }, 450);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
